module.exports = __webpack_public_path__ + "img/InvitaYgana_learn.4afa9901.png";